import { createContext } from 'react';
import { TemplateSectionItem } from 'config.type';
import { Issue } from '../../../constants';

export const HomeContext = createContext<HomeContextProps>({
    selectedSection: '',
    onChangeSection: () => { },
    setShowLogout: () => { },
    sectionsMap: new Map<string, TemplateSectionItem>(),
    userFeatures: new Set(),
    onClickDisabledIssue: (i: Issue) => { },
    hasUserAccess: (f: Set<string>, issue: Issue): boolean => { return false },
    setIsSubscriptionDialogOpen: () => { },
});

interface HomeContextProps {
    selectedSection: string;
    onChangeSection: (id: string) => void;
    sectionsMap: Map<string, TemplateSectionItem>;
    userFeatures: Set<string>
    setShowLogout: any;
    onClickDisabledIssue: (issue: Issue) => void;
    hasUserAccess: (features: Set<string>, issue: Issue) => boolean
    setIsSubscriptionDialogOpen: (isOpen: boolean) => void;
}